module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "svg-sprite.svg#arrow",
      toString: function () {
        return this.url;
      }
    }